import React, { useState } from 'react';
import { ArrowLeftIcon, PlusIcon, SaveIcon, TrashIcon } from 'lucide-react';
import { RecipeDetail } from './RecipeDetail';
import { NewRecipeForm } from './NewRecipeForm';
interface RecipeManagementProps {
  onBackToOverview?: () => void;
}
export function RecipeManagement({
  onBackToOverview
}: RecipeManagementProps) {
  const [view, setView] = useState<'list' | 'detail' | 'new'>('list');
  const [selectedRecipe, setSelectedRecipe] = useState<string | null>(null);
  // Mock-Daten für Rezepte
  const [recipes, setRecipes] = useState([{
    id: '10632',
    name: 'Gustoria Paella'
  }, {
    id: '10633',
    name: 'Gustoria Risotto'
  }, {
    id: '10634',
    name: 'Gustoria Pasta Bolognese'
  }]);
  const handleRecipeClick = (recipeId: string) => {
    setSelectedRecipe(recipeId);
    setView('detail');
  };
  const handleBackToList = () => {
    setView('list');
    setSelectedRecipe(null);
  };
  const handleNewRecipe = () => {
    setView('new');
  };
  const handleSaveNewRecipe = (newRecipe: {
    id: string;
    name: string;
  }) => {
    // Füge das neue Rezept zur Liste hinzu
    setRecipes([...recipes, newRecipe]);
    // Wähle das neue Rezept aus und wechsle direkt zur Detailansicht
    setSelectedRecipe(newRecipe.id);
    setView('detail');
  };
  // Finde das aktuell ausgewählte Rezept
  const currentRecipe = recipes.find(recipe => recipe.id === selectedRecipe);
  return <div className="container mx-auto" data-id="element-1378">
      <div className="mb-8" data-id="element-1379">
        <div data-id="element-1380">
          <h2 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-1381">Stammdaten</h2>
          <p className="text-gray-600 mb-4" data-id="element-1382">
            Verwaltung von Rezepten und Produktspezifikationen
          </p>
          {onBackToOverview}
        </div>
      </div>
      {view === 'list' ? <div className="bg-white rounded-xl shadow-md p-6" data-id="element-1383">
          <div className="flex justify-between items-center mb-6" data-id="element-1384">
            <h3 className="text-xl font-bold text-gray-800" data-id="element-1385">Rezeptübersicht</h3>
            <button onClick={handleNewRecipe} className="flex items-center gap-2 bg-[#8DC63F] hover:bg-[#7AB929] text-white px-4 py-2 rounded-lg transition-colors" data-id="element-1386">
              <PlusIcon size={18} data-id="element-1387" />
              <span data-id="element-1388">Neues Rezept</span>
            </button>
          </div>
          <div className="overflow-hidden border border-gray-200 rounded-lg" data-id="element-1389">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-1390">
              <thead className="bg-gray-50" data-id="element-1391">
                <tr data-id="element-1392">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1393">
                    Rezept-Nr.
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1394">
                    Bezeichnung
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1395">
                    Aktionen
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-1396">
                {recipes.map(recipe => <tr key={recipe.id} className="hover:bg-gray-50" data-id="element-1397">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1398">
                      {recipe.id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1399">
                      {recipe.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1400">
                      <div className="flex gap-2" data-id="element-1401">
                        <button onClick={() => handleRecipeClick(recipe.id)} className="text-blue-600 hover:text-blue-800" data-id="element-1402">
                          Bearbeiten
                        </button>
                        <button className="text-red-600 hover:text-red-800" data-id="element-1403">
                          Löschen
                        </button>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div> : view === 'detail' ? <div data-id="element-1404">
          <button onClick={handleBackToList} className="flex items-center gap-2 mb-4 text-gray-600 hover:text-gray-800" data-id="element-1405">
            <ArrowLeftIcon size={16} data-id="element-1406" />
            <span data-id="element-1407">Zurück zur Übersicht</span>
          </button>
          {selectedRecipe && currentRecipe && <RecipeDetail recipeId={selectedRecipe} recipeName={currentRecipe.name} isNewRecipe={recipes.findIndex(r => r.id === selectedRecipe) === recipes.length - 1} data-id="element-1408" />}
        </div> : <div data-id="element-1409">
          <button onClick={handleBackToList} className="flex items-center gap-2 mb-4 text-gray-600 hover:text-gray-800" data-id="element-1410">
            <ArrowLeftIcon size={16} data-id="element-1411" />
            <span data-id="element-1412">Zurück zur Übersicht</span>
          </button>
          <NewRecipeForm onSave={handleSaveNewRecipe} onCancel={handleBackToList} data-id="element-1413" />
        </div>}
    </div>;
}